import { getApiErrorMessage } from './errors';
import { apiFetch } from './fetch';

export type EnqueueUploadJobResponse = {
  uploadJobId: string;
  status: 'Pending' | 'Processing' | 'Succeeded' | 'Failed';
};

export async function enqueueDocumentUploadAsync(
  documentId: string,
  formData: FormData,
  multiImage = false,
): Promise<EnqueueUploadJobResponse> {
  const path = multiImage
    ? `/api/documents/${documentId}/upload-images-async`
    : `/api/documents/${documentId}/upload-async`;
  const res = await apiFetch(path, { method: 'POST', body: formData });
  if (!res.ok) {
    const message = await getApiErrorMessage(res);
    throw new Error(message ?? 'upload enqueue failed');
  }
  return res.json();
}
